/**
 * Body editor for the field_decl step: field name, engine storage type,
 * and the optional initial value (placeholder text adapts to the type).
 */
import React from "react"
import { Radio } from "antd"
import type { RadioChangeEvent } from "antd"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { FieldDeclStep } from "types/queryBuilder.types"
import { StepBodyProps } from "./stepBodyProps"

export interface FieldDeclStepBodyProps extends StepBodyProps<FieldDeclStep> {
  renameStep: QueryBuilderStore["renameTransformStep"]
  setFieldDeclType: QueryBuilderStore["setFieldDeclType"]
  setFieldDeclInitialValue: QueryBuilderStore["setFieldDeclInitialValue"]
}

const FieldDeclStepBody: React.FC<FieldDeclStepBodyProps> = ({
  step,
  renameStep,
  setFieldDeclType,
  setFieldDeclInitialValue,
}) => (
  <>
    <input
      className="qc-recodes__name qc-mono"
      type="text"
      value={step.name}
      onChange={(e) => renameStep(step.id, e.target.value)}
      placeholder="Field name (e.g. 'Sample weight', or 'Age//Bucket' to nest)"
      aria-label="Field name"
    />
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Type:</span>
      <Radio.Group
        value={step.fieldType}
        onChange={(e: RadioChangeEvent) =>
          setFieldDeclType(step.id, e.target.value)
        }
        size="small"
      >
        <Radio.Button value="BOOL">BOOL (yes/no)</Radio.Button>
        <Radio.Button value="INT">INT (integer)</Radio.Button>
        <Radio.Button value="REAL">REAL (decimal)</Radio.Button>
        <Radio.Button value="TEXT">TEXT</Radio.Button>
      </Radio.Group>
    </div>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Initial value:</span>
      <input
        className="qc-recodes__name qc-mono"
        type="text"
        value={step.initialValue}
        onChange={(e) => setFieldDeclInitialValue(step.id, e.target.value)}
        placeholder={
          step.fieldType === "BOOL"
            ? "true / false (leave blank for null)"
            : step.fieldType === "INT"
            ? "Integer (e.g. 0) — leave blank for null"
            : step.fieldType === "REAL"
            ? "Number (e.g. 1.0) — leave blank for null"
            : "Free text — leave blank for null"
        }
        aria-label="Initial value"
        style={{ flex: 1 }}
      />
    </div>
  </>
)

export default FieldDeclStepBody
